module.exports = __webpack_public_path__ + "static/media/fly_anywhere_sm.05357e69.png";